<template>
    <el-dialog :visible.sync="show"
        :title="$t('operations.turnOnDeleteProtect.name')"
        :close-on-click-modal="false"
        :before-close="handleClose"
        width="30%"
        class="del-root">
        <p>{{ $t('privateNetInstance.turnOnDeleteProtectTip', [instanceName]) }}</p>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">{{ $t('privateNetInstance.cancel') }}</el-button>
            <el-button @click="handleSure" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'EnableDeletionProtection',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        instanceName: {
            type: String,
            default: ''
        },
        instanceId: {
            type: String,
            default: ''
        },
        region: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: false
        };
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        }
    },
    methods: {
        handleClose() {
            this.show = false;
            this.$emit('update:visible', false);
        },
        handleCancel() {
            this.handleClose();
        },
        handleSure() {
            const params = {
                region: this.region,
                instanceId: this.instanceId,
                removeProtect: "yes"
            };
            Ajax.post('/api/cps/modifyInstanceRemoveProtect', params)
            .then((res) => {
                this.$message.success(this.$t('privateNetInstance.operateSuccess'));
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.handleClose();
                this.$emit('refresh');
            });
        }
    },
};
</script>

<style scoped lang="scss">
    .del-root {
        p {
            text-align: left;
            margin: 12px;
            line-height: 1.5;
            color: #212121;
            word-break: break-all;
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/enableDeletionProtection/EnableDeletionProtection.vue